.Toast {
  align-items: flex-start;
  background-color: var(--rv-surface);
  border: 1px solid var(--rv-border);
  border-radius: var(--rv-radius-lg);
  box-shadow: var(--rv-shadow-md);
  color: var(--rv-fg-1);
  display: flex;
  font-family: var(--rv-font-ui);
  font-size: var(--rv-text-sm);
  gap: var(--rv-space-3);
  justify-content: space-between;
  padding: var(--rv-space-3) var(--rv-space-4);

  & button,
  & button:active,
  & button:focus {
    background: none;
    border: 0;
    border-radius: var(--rv-radius-sm);
    cursor: pointer;
    display: flex;
    height: var(--rv-icon-md);
    margin: 0;
    outline: 0;
    padding: 0;
    width: var(--rv-icon-md);

    &:hover {
      background-color: var(--rv-bg-app-subtle);
    }
  }

  &.success {
    background-color: var(--rv-success-bg);
    border-color: var(--color-green-200);
    color: var(--rv-success-ink);

    & button:hover {
      background-color: var(--color-green-100);
    }

    & a {
      color: var(--rv-success-ink);
      text-decoration: underline;
    }
  }

  &.error {
    background-color: var(--rv-danger-bg);
    border-color: var(--color-red-200);
    color: var(--rv-danger-ink);

    & button:hover {
      background-color: var(--color-red-100);
    }
  }

  &.warning {
    background-color: var(--rv-warning-bg);
    border-color: var(--color-yellow-200);
    color: var(--rv-warning-ink);

    & button:hover {
      background-color: var(--color-yellow-100);
    }
  }

  & .CloseIcon {
    fill: currentcolor;
    height: var(--rv-icon-sm);
    margin: auto;
    width: var(--rv-icon-sm);
  }
}
